<template>
  <BaseList
    document-type="user_roles"
    :show-modal-button="false"
    list-type="toggle"
    meta-name="User Roles"
    api-items-field="roles"
    path="/app/settings/organization-settings/user-roles"
    :list-field-names="{ main: '', status: 'Can edit posts', toggleModel: 'allowJobAccess' }"
    :toggle-actions="{ active: 'grant', inactive: 'revoke' }"
    :api-names="{
      load: 'settingsGetUserRoles',
      post: 'settingsUpdateUserRoles',
    }"
  />
</template>

<script>
import BaseList from './components/lists/BaseList.vue';

export default {
  name: 'UserRoles',
  components: {
    BaseList,
  },
};
</script>
